/**
 * Empty state.
 *
 * Always carries an action or a next step. "No results" with nothing to do is a dead end, and the
 * screens where this appears — an empty knowledge base, an empty supervision queue, a question the
 * corpus cannot answer — are exactly the moments where the user needs telling what to do next.
 */

import type { ReactNode } from "react";

import { cx } from "./cx";

export interface EmptyStateProps {
  title: string;
  description?: string;
  /** The next step. Optional only because an empty queue is genuinely good news. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  description,
  action,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cx(
        "flex flex-col items-center gap-2 rounded-md border border-dashed border-borderStrong",
        "bg-surfaceSunken px-6 py-10 text-center",
        className,
      )}
    >
      <p className="text-heading-sm text-textPrimary">{title}</p>
      {description ? (
        <p className="max-w-prose text-body-sm text-textMuted">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
